export const MOBILE_PAGE_CONFIG = {
  "title": "Country Comparison",
  "titleCN": "国家对比",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/comparisonAnalysis/countryComparison",
  "defaultTab": "country_comparison",
  "tabList": [
    {
      "id": "country_comparison",
      "isHaveNotification": true,
      "notificationPath": "/comparisonAnalysis/countryComparison",
      "path": "/comparisonAnalysis/countryComparison",
      "tabIcon": "chart-map",
      "logConfig": {
        "pageId": "201601",
        "pageName": "comparisonAnalysisCountryComparison",
        "extInfo": "comparisonAnalysisCountryComparison",
        "pagePath": "/comparisonAnalysis/countryComparison",
        "typeId": "dashboard_pc_v2"
      },
      "filters": [
        {
          "name": "CountryComparisonFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/comparisonAnalysis/countryComparison",
          "data": {
            "typeList": [
              "date",
              "week",
              "month"
            ]
          },
          "componentList": [
            {
              "name": "CountryComparisonService",
              "className": "",
              "type": "view",
              "style": {},
              "data": {
                "metric": "new_users"
              },
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/comparison_analysis/country/linechart",
                  "isDark": true,
                  "dataKey": "country_line_chart"
                }
              },
              "children": [
                {
                  "name": "SegmentTabsCo",
                  "props": {
                    "config": {
                      "dataKey": "metric",
                      "tabList": {
                        "Day": [
                          {
                            "id": "TNU",
                            "indicatorsName": "tnu",
                            "resName": "total_users",
                            "resAvgName": "",
                            "name": "TNU",
                            "nameCn": "总注册用户数",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "Total NEW Users. Total number of registered users accumulated to the statistical day (vopenid deduplicated).",
                            "explainCn": "累计至统计日的注册用户总数(vopenid数去重)。"
                          },
                          {
                            "id": "New",
                            "indicatorsName": "new",
                            "resName": "new_users",
                            "resAvgName": "",
                            "name": "New",
                            "nameCn": "新进用户",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "New Register Users.Total number of newly-registered users in the statistical period (vopenid deduplicated).",
                            "explainCn": "统计周期内新注册用户数(vopenid数去重)。"
                          },
                          {
                            "id": "DAU",
                            "indicatorsName": "dau",
                            "resName": "active_users",
                            "resAvgName": "",
                            "name": "DAU",
                            "nameCn": "日活跃",
                            "rainbowKey": "DAU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Revenue",
                            "indicatorsName": "revenue",
                            "resName": "pay_amount",
                            "resAvgName": "",
                            "name": "Revenue($)",
                            "nameCn": "付费金额($)",
                            "rainbowKey": "Revenue($)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "PCU",
                            "indicatorsName": "pcu",
                            "resName": "pcu",
                            "resAvgName": "",
                            "name": "PCU",
                            "nameCn": "最高同时在线",
                            "rainbowKey": "PCU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "ACU",
                            "indicatorsName": "acu",
                            "resName": "acu",
                            "resAvgName": "",
                            "name": "ACU",
                            "nameCn": "平均同时在线",
                            "rainbowKey": "ACU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Avg.Playtime(min)",
                            "indicatorsName": "aot",
                            "resName": "aot",
                            "resAvgName": "",
                            "name": "Avg.Playtime(min)",
                            "nameCn": "平均在线时长(分钟)",
                            "rainbowKey": "Avg.Playtime(min)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "D2",
                            "resName": "d2",
                            "indicatorsName": "d237",
                            "resAvgName": "",
                            "name": "D2",
                            "nameCn": "次留",
                            "rainbowKey": "D2",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "D3",
                            "resName": "d3",
                            "indicatorsName": "d3",
                            "resAvgName": "",
                            "name": "D3",
                            "nameCn": "3留",
                            "rainbowKey": "D3",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "D4",
                            "resName": "d4",
                            "indicatorsName": "d4",
                            "resAvgName": "",
                            "name": "D4",
                            "nameCn": "4留",
                            "rainbowKey": "D4",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "D5",
                            "resName": "d5",
                            "indicatorsName": "d5",
                            "resAvgName": "",
                            "name": "D5",
                            "nameCn": "5留",
                            "rainbowKey": "D5",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "D6",
                            "resName": "d6",
                            "indicatorsName": "d6",
                            "resAvgName": "",
                            "name": "D6",
                            "nameCn": "6留",
                            "rainbowKey": "D6",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "D7",
                            "resName": "d7",
                            "indicatorsName": "d7",
                            "resAvgName": "",
                            "name": "D7",
                            "nameCn": "7留",
                            "rainbowKey": "D7",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Payer",
                            "resName": "paid_users",
                            "indicatorsName": "payer",
                            "resAvgName": "",
                            "name": "Payer",
                            "nameCn": "付费人数",
                            "rainbowKey": "Payer",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Payer%",
                            "resName": "payer_rate",
                            "indicatorsName": "payer_ratio",
                            "resAvgName": "",
                            "name": "Payer%",
                            "nameCn": "付费渗透率",
                            "rainbowKey": "Payer%",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "ARPU",
                            "resName": "arpu",
                            "indicatorsName": "arpu",
                            "resAvgName": "",
                            "name": "ARPU($)",
                            "nameCn": "活跃ARPU($)",
                            "rainbowKey": "ARPU($)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 5,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "ARPPU",
                            "resName": "arppu",
                            "indicatorsName": "arppu",
                            "resAvgName": "",
                            "name": "ARPPU($)",
                            "nameCn": "付费ARPPU($)",
                            "rainbowKey": "ARPPU($)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "New Payer",
                            "resName": "new_paid_users",
                            "indicatorsName": "newPayer",
                            "resAvgName": "",
                            "name": "First-time Payer",
                            "nameCn": "首次付费用户",
                            "rainbowKey": "First-time Payer",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Revenue(new payer)",
                            "resName": "new_pay_amount",
                            "indicatorsName": "revenue",
                            "resAvgName": "",
                            "name": "Revenue(first-time payer)",
                            "nameCn": "首次付费用户金额",
                            "rainbowKey": "Revenue(first-time payer)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "New Users ARPPU($)",
                            "resName": "new_arppu",
                            "indicatorsName": "newArppu",
                            "resAvgName": "",
                            "name": "First-time Payer ARPPU($)",
                            "nameCn": "首次付费用户ARPPU($)",
                            "rainbowKey": "First-time Payer ARPPU($)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Sessions per user",
                            "resName": "alc",
                            "indicatorsName": "alc",
                            "resAvgName": "",
                            "name": "Sessions per user",
                            "nameCn": "平均登录次数",
                            "rainbowKey": "Sessions per user",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "DAU Retention Users",
                            "resName": "retention_users",
                            "indicatorsName": "retentionUsers",
                            "resAvgName": "",
                            "name": "DAU Retention Users",
                            "nameCn": "日活留存",
                            "rainbowKey": "DAU Retention Users",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Churn Users",
                            "resName": "churn_users",
                            "indicatorsName": "churnUsers",
                            "resAvgName": "",
                            "name": "Churn Users",
                            "nameCn": "日流失",
                            "rainbowKey": "Churn Users",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Churn%",
                            "resName": "churn_rate",
                            "indicatorsName": "churnRate",
                            "resAvgName": "",
                            "name": "Churn%",
                            "nameCn": "流失率",
                            "rainbowKey": "Churn%",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "DAU Return Users",
                            "resName": "return_users",
                            "indicatorsName": "returnUsers",
                            "resAvgName": "",
                            "name": "DAU Return Users",
                            "nameCn": "日回流",
                            "rainbowKey": "DAU Return Users",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Weighted D2",
                            "resName": "weighted_d2",
                            "indicatorsName": "weighted_d2",
                            "resAvgName": "",
                            "name": "Weighted D2",
                            "nameCn": "加权次留",
                            "rainbowKey": "Weighted D2",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Weighted D3",
                            "resName": "weighted_d3",
                            "indicatorsName": "weighted_d3",
                            "resAvgName": "",
                            "name": "Weighted D3",
                            "nameCn": "加权3留",
                            "rainbowKey": "Weighted D3",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Weighted D7",
                            "resName": "weighted_d7",
                            "indicatorsName": "weighted_d7",
                            "resAvgName": "",
                            "name": "Weighted D7",
                            "nameCn": "加权7留",
                            "rainbowKey": "Weighted D7",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Weighted D14",
                            "resName": "weighted_d14",
                            "indicatorsName": "weightedD14",
                            "resAvgName": "",
                            "name": "Weighted D14",
                            "nameCn": "加权14留",
                            "rainbowKey": "Weighted D14",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "1st Order Login%",
                            "resName": "first_login_ratio",
                            "indicatorsName": "firstLoginRatio",
                            "resAvgName": "",
                            "name": "1st Order Login%",
                            "nameCn": "一阶登录比",
                            "rainbowKey": "1st Order Login%",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "2nd Order Login%",
                            "resName": "second_login_ratio",
                            "indicatorsName": "secondLoginRatio",
                            "resAvgName": "",
                            "name": "2nd Order Login%",
                            "nameCn": "二阶登录比",
                            "rainbowKey": "2nd Order Login%",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          }
                        ],
                        "Week": [
                          {
                            "id": "TRU",
                            "resName": "total_users",
                            "indicatorsName": "tru",
                            "resAvgName": "",
                            "name": "TNU",
                            "nameCn": "总注册用户数",
                            "rainbowKey": "TNU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "New",
                            "resName": "new_users",
                            "indicatorsName": "new",
                            "resAvgName": "",
                            "name": "New",
                            "nameCn": "新进用户",
                            "rainbowKey": "New",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Avg.Daily New",
                            "resName": "avg_new_users",
                            "indicatorsName": "avgNewUsers",
                            "resAvgName": "",
                            "name": "Avg.Daily New",
                            "nameCn": "平均每日新进用户数",
                            "rainbowKey": "Avg.Daily New",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "WAU",
                            "resName": "active_users",
                            "indicatorsName": "wau",
                            "resAvgName": "",
                            "name": "WAU",
                            "nameCn": "WAU",
                            "rainbowKey": "WAU",
                            "avgName": "周活跃",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Week Avg.DAU",
                            "resName": "avg_active_users",
                            "indicatorsName": "avg.wau",
                            "resAvgName": "",
                            "name": "Week Avg.DAU",
                            "nameCn": "周平均日活跃",
                            "rainbowKey": "Week Avg.DAU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Revenue",
                            "resName": "pay_amount",
                            "indicatorsName": "revenue",
                            "resAvgName": "",
                            "name": "Revenue($)",
                            "nameCn": "付费金额($)",
                            "rainbowKey": "Revenue($)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Week Avg.Revenue($)",
                            "resName": "avg_pay_amount",
                            "indicatorsName": "avgPayAmount",
                            "resAvgName": "",
                            "name": "Week Avg.Revenue($)",
                            "nameCn": "周平均付费金额($)",
                            "rainbowKey": "Week Avg.Revenue($)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "PCU",
                            "resName": "pcu",
                            "indicatorsName": "pcu",
                            "resAvgName": "",
                            "name": "PCU",
                            "nameCn": "最高同时在线",
                            "rainbowKey": "PCU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "ACU",
                            "resName": "acu",
                            "indicatorsName": "acu",
                            "resAvgName": "",
                            "name": "ACU",
                            "nameCn": "平均同时在线",
                            "rainbowKey": "ACU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Avg.Playtime(min)",
                            "resName": "aot",
                            "indicatorsName": "aot",
                            "resAvgName": "",
                            "name": "Avg.Playtime(min)",
                            "nameCn": "平均在线时长(分钟)",
                            "rainbowKey": "Avg.Playtime(min)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Avg.Daily Playtime(min)",
                            "resName": "saot",
                            "indicatorsName": "saot",
                            "resAvgName": "",
                            "name": "Avg.Daily Playtime(min)",
                            "nameCn": "周日平均在线时长(分钟)",
                            "rainbowKey": "Avg.Daily Playtime(min)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "W2",
                            "resName": "w2",
                            "indicatorsName": "w23",
                            "resAvgName": "",
                            "name": "W2",
                            "nameCn": "次周留存",
                            "rainbowKey": "W2",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "W3",
                            "resName": "w3",
                            "indicatorsName": "w3",
                            "resAvgName": "",
                            "name": "W3",
                            "nameCn": "3周留存",
                            "rainbowKey": "W3",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "W4",
                            "resName": "w4",
                            "indicatorsName": "w4",
                            "resAvgName": "",
                            "name": "W4",
                            "nameCn": "4周留存",
                            "rainbowKey": "W4",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Payer",
                            "resName": "paid_users",
                            "indicatorsName": "payer",
                            "resAvgName": "",
                            "name": "Payer",
                            "nameCn": "付费人数",
                            "rainbowKey": "Payer",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Payer%",
                            "resName": "payer_rate",
                            "indicatorsName": "payer_ratio",
                            "resAvgName": "",
                            "name": "Payer%",
                            "nameCn": "付费渗透率",
                            "rainbowKey": "Payer%",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "ARPU",
                            "resName": "arpu",
                            "indicatorsName": "arpu",
                            "resAvgName": "",
                            "name": "ARPU($)",
                            "nameCn": "活跃ARPU($)",
                            "rainbowKey": "ARPU($)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 5,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "ARPPU",
                            "resName": "arppu",
                            "indicatorsName": "arppu",
                            "resAvgName": "",
                            "name": "ARPPU($)",
                            "nameCn": "付费ARPPU($)",
                            "rainbowKey": "ARPPU($)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "New Payer",
                            "resName": "new_paid_users",
                            "indicatorsName": "newPaidUsers",
                            "resAvgName": "",
                            "name": "First-time Payer",
                            "nameCn": "首次付费用户",
                            "rainbowKey": "First-time Payer",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Revenue(new payer)",
                            "resName": "new_pay_amount",
                            "indicatorsName": "newPayAmount",
                            "resAvgName": "",
                            "name": "Revenue(first-time payer)",
                            "nameCn": "首次付费用户金额",
                            "rainbowKey": "Revenue(first-time payer)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "New Users ARPPU($)",
                            "resName": "new_arppu",
                            "indicatorsName": "newArppu",
                            "resAvgName": "",
                            "name": "First-time Payer ARPPU($)",
                            "nameCn": "首次付费用户ARPPU($)",
                            "rainbowKey": "First-time Payer ARPPU($)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Sessions per user",
                            "resName": "alc",
                            "indicatorsName": "alc",
                            "resAvgName": "",
                            "name": "Sessions per user",
                            "nameCn": "平均登录次数",
                            "rainbowKey": "Sessions per user",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "WAU Retention Users",
                            "resName": "retention_users",
                            "indicatorsName": "retentionUsers",
                            "resAvgName": "",
                            "name": "WAU Retention Users",
                            "nameCn": "周活留存",
                            "rainbowKey": "WAU Retention Users",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Churn Users",
                            "resName": "churn_users",
                            "indicatorsName": "churnUsers",
                            "resAvgName": "",
                            "name": "Churn Users",
                            "nameCn": "周流失",
                            "rainbowKey": "Churn Users",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Churn%",
                            "resName": "churn_rate",
                            "indicatorsName": "churnRate",
                            "resAvgName": "",
                            "name": "Churn%",
                            "nameCn": "流失率",
                            "rainbowKey": "Churn%",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "WAU Return Users",
                            "resName": "return_users",
                            "indicatorsName": "returnUsers",
                            "resAvgName": "",
                            "name": "WAU Return Users",
                            "nameCn": "周回流",
                            "rainbowKey": "WAU Return Users",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Weighted W2",
                            "resName": "weighted_w2",
                            "indicatorsName": "weighted_w2",
                            "resAvgName": "",
                            "name": "Weighted W2",
                            "nameCn": "加权次周留存",
                            "rainbowKey": "Weighted W2",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Weighted W3",
                            "resName": "weighted_w3",
                            "indicatorsName": "weighted_w3",
                            "resAvgName": "",
                            "name": "Weighted W3",
                            "nameCn": "加权3周留存",
                            "rainbowKey": "Weighted W3",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Weighted W4",
                            "resName": "weighted_w4",
                            "indicatorsName": "weighted_w4",
                            "resAvgName": "",
                            "name": "Weighted W4",
                            "nameCn": "加权4周留存",
                            "rainbowKey": "Weighted W4",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          }
                        ],
                        "Month": [
                          {
                            "id": "TRU",
                            "resName": "total_users",
                            "indicatorsName": "tru",
                            "resAvgName": "",
                            "name": "TNU",
                            "nameCn": "总注册用户数",
                            "rainbowKey": "TNU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "New",
                            "resName": "new_users",
                            "indicatorsName": "new",
                            "resAvgName": "",
                            "name": "New",
                            "nameCn": "新进用户",
                            "rainbowKey": "New",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Avg.Daily New",
                            "resName": "avg_new_users",
                            "indicatorsName": "avgNewUsers",
                            "resAvgName": "",
                            "name": "Avg.Daily New",
                            "nameCn": "平均每日新进用户数",
                            "rainbowKey": "Avg.Daily New",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "MAU",
                            "resName": "active_users",
                            "indicatorsName": "mau",
                            "resAvgName": "",
                            "name": "MAU",
                            "nameCn": "月活跃",
                            "rainbowKey": "MAU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Month Avg.DAU",
                            "resName": "avg_active_users",
                            "indicatorsName": "avg.mau",
                            "resAvgName": "",
                            "name": "Month Avg.DAU",
                            "nameCn": "月平均日活跃",
                            "rainbowKey": "Month Avg.DAU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Revenue",
                            "resName": "pay_amount",
                            "indicatorsName": "revenue",
                            "resAvgName": "",
                            "name": "Revenue($)",
                            "nameCn": "付费金额($)",
                            "rainbowKey": "Revenue($)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Month Avg.Revenue($)",
                            "resName": "avg_pay_amount",
                            "indicatorsName": "avgPayAmount",
                            "resAvgName": "",
                            "name": "Month Avg.Revenue($)",
                            "nameCn": "月均付费金额($)",
                            "rainbowKey": "Month Avg.Revenue($)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "PCU",
                            "resName": "pcu",
                            "indicatorsName": "pcu",
                            "resAvgName": "",
                            "name": "PCU",
                            "nameCn": "最高同时在线",
                            "rainbowKey": "PCU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "ACU",
                            "resName": "acu",
                            "indicatorsName": "acu",
                            "resAvgName": "",
                            "name": "ACU",
                            "nameCn": "平均同时在线",
                            "rainbowKey": "ACU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Avg.Playtime(min)",
                            "resName": "aot",
                            "indicatorsName": "aot",
                            "resAvgName": "",
                            "name": "Avg.Playtime(min)",
                            "nameCn": "平均在线时长(分钟)",
                            "rainbowKey": "Avg.Playtime(min)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "M2",
                            "resName": "m2",
                            "indicatorsName": "m23",
                            "resAvgName": "",
                            "name": "M2",
                            "nameCn": "次月留存",
                            "rainbowKey": "M2",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "M3",
                            "resName": "m3",
                            "indicatorsName": "m3",
                            "resAvgName": "",
                            "name": "M3",
                            "nameCn": "3月留存",
                            "rainbowKey": "M3",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "M4",
                            "resName": "m4",
                            "indicatorsName": "m4",
                            "resAvgName": "",
                            "name": "M4",
                            "nameCn": "4月留存",
                            "rainbowKey": "M4",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Payer",
                            "resName": "paid_users",
                            "indicatorsName": "payer",
                            "resAvgName": "",
                            "name": "Payer",
                            "nameCn": "付费人数",
                            "rainbowKey": "Payer",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Payer%",
                            "resName": "payer_rate",
                            "indicatorsName": "payer_ratio",
                            "resAvgName": "",
                            "name": "Payer%",
                            "nameCn": "付费渗透率",
                            "rainbowKey": "Payer%",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "ARPU",
                            "resName": "arpu",
                            "indicatorsName": "arpu",
                            "resAvgName": "",
                            "name": "ARPU($)",
                            "nameCn": "活跃ARPU($)",
                            "rainbowKey": "ARPU($)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 5,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "ARPPU",
                            "resName": "arppu",
                            "indicatorsName": "arppu",
                            "resAvgName": "",
                            "name": "ARPPU($)",
                            "nameCn": "付费ARPPU($)",
                            "rainbowKey": "ARPPU($)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "New Payer",
                            "resName": "new_paid_users",
                            "indicatorsName": "newPaidUsers",
                            "resAvgName": "",
                            "name": "First-time Payer",
                            "nameCn": "首次付费用户",
                            "rainbowKey": "First-time Payer",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Revenue(new payer)",
                            "resName": "new_pay_amount",
                            "indicatorsName": "newPayAmount",
                            "resAvgName": "",
                            "name": "Revenue(first-time payer)",
                            "nameCn": "首次付费用户金额",
                            "rainbowKey": "Revenue(first-time payer)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "New Users ARPPU($)",
                            "resName": "new_arppu",
                            "indicatorsName": "newArppu",
                            "resAvgName": "",
                            "name": "First-time Payer ARPPU($)",
                            "nameCn": "首次付费用户ARPPU($)",
                            "rainbowKey": "First-time Payer ARPPU($)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Sessions per user",
                            "resName": "alc",
                            "indicatorsName": "alc",
                            "resAvgName": "",
                            "name": "Sessions per user",
                            "nameCn": "平均登录次数",
                            "rainbowKey": "Sessions per user",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "MAU Retention Users",
                            "resName": "retention_users",
                            "indicatorsName": "retentionUsers",
                            "resAvgName": "",
                            "name": "MAU Retention Users",
                            "nameCn": "月活留存",
                            "rainbowKey": "MAU Retention Users",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Churn Users",
                            "resName": "churn_users",
                            "indicatorsName": "churnUsers",
                            "resAvgName": "",
                            "name": "Churn Users",
                            "nameCn": "月流失",
                            "rainbowKey": "Churn Users",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Churn%",
                            "resName": "churn_rate",
                            "indicatorsName": "churnRate",
                            "resAvgName": "",
                            "name": "Churn%",
                            "nameCn": "流失率",
                            "rainbowKey": "Churn%",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "MAU Return Users",
                            "resName": "return_users",
                            "indicatorsName": "returnUsers",
                            "resAvgName": "",
                            "name": "MAU Return Users",
                            "nameCn": "月回流",
                            "rainbowKey": "MAU Return Users",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Weighted M2",
                            "resName": "weighted_m2",
                            "indicatorsName": "weighted_m2",
                            "resAvgName": "",
                            "name": "Weighted M2",
                            "nameCn": "加权次月留存",
                            "rainbowKey": "Weighted M2",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Weighted M3",
                            "resName": "weighted_m3",
                            "indicatorsName": "weighted_m3",
                            "resAvgName": "",
                            "name": "Weighted M3",
                            "nameCn": "加权3月留存",
                            "rainbowKey": "Weighted M3",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          },
                          {
                            "id": "Weighted M4",
                            "resName": "weighted_m4",
                            "indicatorsName": "weighted_m4",
                            "resAvgName": "",
                            "name": "Weighted M4",
                            "nameCn": "加权4月留存",
                            "rainbowKey": "Weighted M4",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1,
                            "explainEn": "",
                            "explainCn": ""
                          }
                        ]
                      }
                    }
                  },
                  "children": [
                    {
                      "name": "CountryComparisonChart"
                    }
                  ]
                }
              ]
            },
            {
              "name": "OverallTableCo",
              "className": "margin-t-20",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "isHaveDiff": false,
                  "useTime": true,
                  "showStatistic": [
                    "sum",
                    "avg_no_null"
                  ],
                  "slotConfig": {
                    "isShowdownloadConfig": false
                  },
                  "valueTypeConfig": {
                    "valueType": "value_only",
                    "isShowChange": false
                  },
                  "dimensionConfig": {
                    "dateDisabled": false,
                    "defaultAccumulation": [
                      "date",
                      "country"
                    ],
                    "isShowCountryFlag": true
                  },
                  "api": {
                    "tableApi": "/api/v1/dashboard/comparison_analysis/country/overall_performance",
                    "tableDownloadApi": "/api/v1/dashboard/comparison_analysis/country/overall_performance/download"
                  },
                  "titleEn": "Key Metrics Ranking",
                  "titleCn": "关键指标排名",
                  "componentMetricsConfig": {
                    "Day": [
                      {
                        "metricKey": "total_users",
                        "reqMetricKey": "total_users",
                        "enPercentWidth": 180,
                        "cnPercentWidth": 180,
                        "enWidth": 105,
                        "cnWidth": 112,
                        "enName": "TNU",
                        "cnName": "总注册用户数",
                        "rainbowKey": "TNU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1,
                        "explainEn": "",
                        "explainCn": ""
                      },
                      {
                        "metricKey": "new_users",
                        "reqMetricKey": "new_users",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 85,
                        "cnWidth": 85,
                        "enName": "New",
                        "cnName": "新进用户",
                        "rainbowKey": "New",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "active_users",
                        "reqMetricKey": "active_users",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 85,
                        "cnWidth": 85,
                        "enName": "DAU",
                        "cnName": "日活跃",
                        "rainbowKey": "DAU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "pay_amount",
                        "reqMetricKey": "pay_amount",
                        "enPercentWidth": 190,
                        "cnPercentWidth": 190,
                        "enWidth": 115,
                        "cnWidth": 115,
                        "enName": "Revenue($)",
                        "cnName": "付费金额($)",
                        "rainbowKey": "Revenue($)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "pcu",
                        "reqMetricKey": "pcu",
                        "enPercentWidth": 152,
                        "cnPercentWidth": 152,
                        "enWidth": 77,
                        "cnWidth": 112,
                        "enName": "PCU",
                        "cnName": "最高同时在线",
                        "rainbowKey": "PCU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "acu",
                        "reqMetricKey": "acu",
                        "enPercentWidth": 152,
                        "cnPercentWidth": 152,
                        "enWidth": 77,
                        "cnWidth": 112,
                        "enName": "ACU",
                        "cnName": "平均同时在线",
                        "rainbowKey": "ACU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "aot",
                        "reqMetricKey": "aot",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 164,
                        "cnWidth": 190,
                        "enName": "Avg.Playtime(min)",
                        "cnName": "平均在线时长(分钟)",
                        "rainbowKey": "Avg.Playtime(min)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "d2",
                        "reqMetricKey": "d2",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 70,
                        "enName": "D2",
                        "cnName": "次留",
                        "rainbowKey": "D2",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "d3",
                        "reqMetricKey": "d3",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 70,
                        "enName": "D3",
                        "cnName": "3留",
                        "rainbowKey": "D3",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "d4",
                        "reqMetricKey": "d4",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 70,
                        "enName": "D4",
                        "cnName": "4留",
                        "rainbowKey": "D4",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "d5",
                        "reqMetricKey": "d5",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 70,
                        "enName": "D5",
                        "cnName": "5留",
                        "rainbowKey": "D5",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "d6",
                        "reqMetricKey": "d6",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 70,
                        "enName": "D6",
                        "cnName": "6留",
                        "rainbowKey": "D6",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "d7",
                        "reqMetricKey": "d7",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 70,
                        "enName": "D7",
                        "cnName": "7留",
                        "rainbowKey": "D7",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "paid_users",
                        "reqMetricKey": "paid_users",
                        "enPercentWidth": 150,
                        "cnPercentWidth": 150,
                        "enWidth": 64,
                        "cnWidth": 80,
                        "enName": "Payer",
                        "cnName": "付费人数",
                        "rainbowKey": "Payer",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "payer_rate",
                        "reqMetricKey": "payer_rate",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 76,
                        "cnWidth": 96,
                        "enName": "Payer%",
                        "cnName": "付费渗透率",
                        "rainbowKey": "Payer%",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "arpu",
                        "reqMetricKey": "arpu",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 126,
                        "enWidth": 96,
                        "cnWidth": 106,
                        "enName": "ARPU($)",
                        "cnName": "活跃ARPU($)",
                        "rainbowKey": "ARPU($)",
                        "type": "decimals",
                        "decimal": 5,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "arppu",
                        "reqMetricKey": "arppu",
                        "enPercentWidth": 152,
                        "cnPercentWidth": 152,
                        "enWidth": 106,
                        "cnWidth": 136,
                        "enName": "ARPPU($)",
                        "cnName": "付费ARPPU($)",
                        "rainbowKey": "ARPPU($)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "new_paid_users",
                        "reqMetricKey": "new_paid_users",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 144,
                        "cnWidth": 126,
                        "enName": "First-time Payer",
                        "cnName": "首次付费用户",
                        "rainbowKey": "First-time Payer",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "new_pay_amount",
                        "reqMetricKey": "new_pay_amount",
                        "enPercentWidth": 220,
                        "cnPercentWidth": 210,
                        "enWidth": 220,
                        "cnWidth": 165,
                        "enName": "Revenue(first-time payer)",
                        "cnName": "首次付费用户金额",
                        "rainbowKey": "Revenue(first-time payer)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "new_arppu",
                        "reqMetricKey": "new_arppu",
                        "enPercentWidth": 240,
                        "cnPercentWidth": 200,
                        "enWidth": 240,
                        "cnWidth": 200,
                        "enName": "First-time Payer ARPPU($)",
                        "cnName": "首次付费用户ARPPU($)",
                        "rainbowKey": "First-time Payer ARPPU($)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "alc",
                        "reqMetricKey": "alc",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 140,
                        "enWidth": 160,
                        "cnWidth": 140,
                        "enName": "Sessions per user",
                        "cnName": "平均登录次数",
                        "rainbowKey": "Sessions per user",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "retention_users",
                        "reqMetricKey": "retention_users",
                        "enPercentWidth": 190,
                        "cnPercentWidth": 190,
                        "enWidth": 200,
                        "cnWidth": 171,
                        "enName": "DAU Retention Users",
                        "cnName": "日活留存",
                        "rainbowKey": "DAU Retention Users",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "churn_users",
                        "reqMetricKey": "churn_users",
                        "enPercentWidth": 170,
                        "cnPercentWidth": 170,
                        "enWidth": 114,
                        "cnWidth": 95,
                        "enName": "Churn Users",
                        "cnName": "日流失",
                        "rainbowKey": "Churn Users",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "churn_rate",
                        "reqMetricKey": "churn_rate",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 80,
                        "cnWidth": 64,
                        "enName": "Churn%",
                        "cnName": "流失率",
                        "rainbowKey": "Churn%",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "return_users",
                        "reqMetricKey": "return_users",
                        "enPercentWidth": 180,
                        "cnPercentWidth": 170,
                        "enWidth": 170,
                        "cnWidth": 95,
                        "enName": "DAU Return Users",
                        "cnName": "日回流",
                        "rainbowKey": "DAU Return Users",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "weighted_d2",
                        "reqMetricKey": "weighted_d2",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 122,
                        "cnWidth": 80,
                        "enName": "Weighted D2",
                        "cnName": "加权次留",
                        "rainbowKey": "Weighted D2",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "weighted_d3",
                        "reqMetricKey": "weighted_d3",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 122,
                        "cnWidth": 80,
                        "enName": "Weighted D3",
                        "cnName": "加权3留",
                        "rainbowKey": "Weighted D3",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "weighted_d7",
                        "reqMetricKey": "weighted_d7",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 122,
                        "cnWidth": 80,
                        "enName": "Weighted D7",
                        "cnName": "加权7留",
                        "rainbowKey": "Weighted D7",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "weighted_d14",
                        "reqMetricKey": "weighted_d14",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 132,
                        "cnWidth": 82,
                        "enName": "Weighted D14",
                        "cnName": "加权14留",
                        "rainbowKey": "Weighted D14",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "first_login_ratio",
                        "reqMetricKey": "first_login_ratio",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 145,
                        "enWidth": 160,
                        "cnWidth": 145,
                        "enName": "1st Order Login%",
                        "cnName": "一阶登录比",
                        "rainbowKey": "1st Order Login%",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "second_login_ratio",
                        "reqMetricKey": "second_login_ratio",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 145,
                        "enWidth": 160,
                        "cnWidth": 145,
                        "enName": "2nd Order Login%",
                        "cnName": "二阶登录比",
                        "rainbowKey": "2nd Order Login%",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      }
                    ],
                    "Week": [
                      {
                        "metricKey": "total_users",
                        "reqMetricKey": "total_users",
                        "enPercentWidth": 180,
                        "cnPercentWidth": 180,
                        "enWidth": 105,
                        "cnWidth": 112,
                        "enName": "TNU",
                        "cnName": "总注册用户数",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1,
                        "enExplain": "Total NEW Users. Total number of registered users accumulated to the statistical day (vopenid deduplicated).",
                        "cnExplain": "累计至统计日的注册用户总数(vopenid数去重)。",
                        "rainbowKey": "TNU"
                      },
                      {
                        "metricKey": "new_users",
                        "reqMetricKey": "new_users",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 85,
                        "cnWidth": 85,
                        "enName": "New",
                        "cnName": "新进用户",
                        "rainbowKey": "New",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "avg_new_users",
                        "reqMetricKey": "avg_new_users",
                        "enPercentWidth": 152,
                        "cnPercentWidth": 167,
                        "enWidth": 136,
                        "cnWidth": 160,
                        "enName": "Avg.Daily New",
                        "cnName": "平均每日新进用户数",
                        "rainbowKey": "Avg.Daily New",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "active_users",
                        "reqMetricKey": "active_users",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 85,
                        "cnWidth": 85,
                        "enName": "WAU",
                        "cnName": "周活跃",
                        "rainbowKey": "WAU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "avg_active_users",
                        "reqMetricKey": "avg_active_users",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 150,
                        "cnWidth": 120,
                        "enName": "Week Avg.DAU",
                        "cnName": "周平均日活跃",
                        "rainbowKey": "Week Avg.DAU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "pay_amount",
                        "reqMetricKey": "pay_amount",
                        "enPercentWidth": 190,
                        "cnPercentWidth": 190,
                        "enWidth": 115,
                        "cnWidth": 115,
                        "enName": "Revenue($)",
                        "cnName": "付费金额($)",
                        "rainbowKey": "Revenue($)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "avg_pay_amount",
                        "reqMetricKey": "avg_pay_amount",
                        "enPercentWidth": 192,
                        "cnPercentWidth": 140,
                        "enWidth": 200,
                        "cnWidth": 150,
                        "enName": "Week Avg.Revenue($)",
                        "cnName": "周平均付费金额($)",
                        "rainbowKey": "Week Avg.Revenue($)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "pcu",
                        "reqMetricKey": "pcu",
                        "enPercentWidth": 152,
                        "cnPercentWidth": 152,
                        "enWidth": 77,
                        "cnWidth": 112,
                        "enName": "PCU",
                        "cnName": "最高同时在线",
                        "rainbowKey": "PCU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "acu",
                        "reqMetricKey": "acu",
                        "enPercentWidth": 152,
                        "cnPercentWidth": 152,
                        "enWidth": 77,
                        "cnWidth": 112,
                        "enName": "ACU",
                        "cnName": "平均同时在线",
                        "rainbowKey": "ACU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "aot",
                        "reqMetricKey": "aot",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 164,
                        "cnWidth": 190,
                        "enName": "Avg.Playtime(min)",
                        "cnName": "平均在线时长(分钟)",
                        "rainbowKey": "Avg.Playtime(min)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "saot",
                        "reqMetricKey": "saot",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 224,
                        "cnWidth": 150,
                        "enName": "Avg.Daily Playtime(min)",
                        "cnName": "周日平均在线时长(分钟)",
                        "rainbowKey": "Avg.Daily Playtime(min)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "w2",
                        "reqMetricKey": "w2",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 80,
                        "enName": "W2",
                        "cnName": "次周留存",
                        "rainbowKey": "W2",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "w3",
                        "reqMetricKey": "w3",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 80,
                        "enName": "W3",
                        "cnName": "3周留存",
                        "rainbowKey": "W3",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "w4",
                        "reqMetricKey": "w4",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 80,
                        "enName": "W4",
                        "rainbowKey": "W4",
                        "cnName": "4周留存",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "paid_users",
                        "reqMetricKey": "paid_users",
                        "enPercentWidth": 150,
                        "cnPercentWidth": 150,
                        "enWidth": 64,
                        "cnWidth": 80,
                        "enName": "Payer",
                        "cnName": "付费人数",
                        "rainbowKey": "Payer",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "payer_rate",
                        "reqMetricKey": "payer_rate",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 76,
                        "cnWidth": 96,
                        "enName": "Payer%",
                        "cnName": "付费渗透率",
                        "rainbowKey": "Payer%",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "arpu",
                        "reqMetricKey": "arpu",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 126,
                        "enWidth": 96,
                        "cnWidth": 106,
                        "enName": "ARPU($)",
                        "cnName": "活跃ARPU($)",
                        "rainbowKey": "ARPU($)",
                        "type": "decimals",
                        "decimal": 5,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "arppu",
                        "reqMetricKey": "arppu",
                        "enPercentWidth": 152,
                        "cnPercentWidth": 152,
                        "enWidth": 106,
                        "cnWidth": 136,
                        "enName": "ARPPU($)",
                        "cnName": "付费ARPPU($)",
                        "rainbowKey": "ARPPU($)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "new_paid_users",
                        "reqMetricKey": "new_paid_users",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 144,
                        "cnWidth": 126,
                        "enName": "First-time Payer",
                        "cnName": "首次付费用户",
                        "rainbowKey": "First-time Payer",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "new_pay_amount",
                        "reqMetricKey": "new_pay_amount",
                        "enPercentWidth": 220,
                        "cnPercentWidth": 210,
                        "enWidth": 220,
                        "cnWidth": 165,
                        "enName": "Revenue(first-time payer)",
                        "cnName": "首次付费用户金额",
                        "rainbowKey": "Revenue(first-time payer)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "new_arppu",
                        "reqMetricKey": "new_arppu",
                        "enPercentWidth": 240,
                        "cnPercentWidth": 200,
                        "enWidth": 240,
                        "cnWidth": 200,
                        "enName": "First-time Payer ARPPU($)",
                        "cnName": "首次付费用户ARPPU($)",
                        "rainbowKey": "First-time Payer ARPPU($)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "alc",
                        "reqMetricKey": "alc",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 140,
                        "enWidth": 160,
                        "cnWidth": 140,
                        "enName": "Sessions per user",
                        "cnName": "平均登录次数",
                        "rainbowKey": "Sessions per user",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "retention_users",
                        "reqMetricKey": "retention_users",
                        "enPercentWidth": 190,
                        "cnPercentWidth": 190,
                        "enWidth": 200,
                        "cnWidth": 171,
                        "enName": "DAU Retention Users",
                        "cnName": "日活留存",
                        "rainbowKey": "DAU Retention Users",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "churn_users",
                        "reqMetricKey": "churn_users",
                        "enPercentWidth": 170,
                        "cnPercentWidth": 170,
                        "enWidth": 114,
                        "cnWidth": 95,
                        "enName": "Churn Users",
                        "cnName": "周流失",
                        "rainbowKey": "Churn Users",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "churn_rate",
                        "reqMetricKey": "churn_rate",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 80,
                        "cnWidth": 64,
                        "enName": "Churn%",
                        "cnName": "流失率",
                        "rainbowKey": "Churn%",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "return_users",
                        "reqMetricKey": "return_users",
                        "enPercentWidth": 180,
                        "cnPercentWidth": 170,
                        "enWidth": 170,
                        "cnWidth": 95,
                        "enName": "WAU Return Users",
                        "cnName": "周回流",
                        "rainbowKey": "WAU Return Users",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "weighted_w2",
                        "reqMetricKey": "weighted_w2",
                        "enPercentWidth": 150,
                        "cnPercentWidth": 145,
                        "enWidth": 126,
                        "cnWidth": 112,
                        "enName": "Weighted W2",
                        "cnName": "加权次周留存",
                        "rainbowKey": "Weighted W2",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "weighted_w3",
                        "reqMetricKey": "weighted_w3",
                        "enPercentWidth": 150,
                        "cnPercentWidth": 145,
                        "enWidth": 126,
                        "cnWidth": 112,
                        "enName": "Weighted W3",
                        "cnName": "加权3周留存",
                        "rainbowKey": "Weighted W3",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "weighted_w4",
                        "reqMetricKey": "weighted_w4",
                        "enPercentWidth": 150,
                        "cnPercentWidth": 145,
                        "enWidth": 126,
                        "cnWidth": 112,
                        "enName": "Weighted W4",
                        "cnName": "加权4周留存",
                        "rainbowKey": "Weighted W4",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      }
                    ],
                    "Month": [
                      {
                        "metricKey": "total_users",
                        "reqMetricKey": "total_users",
                        "enPercentWidth": 180,
                        "cnPercentWidth": 180,
                        "enWidth": 105,
                        "cnWidth": 112,
                        "enName": "TNU",
                        "cnName": "总注册用户数",
                        "rainbowKey": "TNU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1,
                        "explainEn": "",
                        "explainCn": ""
                      },
                      {
                        "metricKey": "new_users",
                        "reqMetricKey": "new_users",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 85,
                        "cnWidth": 85,
                        "enName": "New",
                        "cnName": "新进用户",
                        "rainbowKey": "New",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "avg_new_users",
                        "reqMetricKey": "avg_new_users",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 155,
                        "cnWidth": 130,
                        "enName": "Avg.Daily New",
                        "cnName": "平均每日新进用户数",
                        "rainbowKey": "Avg.Daily New",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "active_users",
                        "reqMetricKey": "active_users",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 85,
                        "cnWidth": 85,
                        "enName": "MAU",
                        "cnName": "月活跃",
                        "rainbowKey": "MAU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "avg_active_users",
                        "reqMetricKey": "avg_active_users",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 150,
                        "cnWidth": 120,
                        "enName": "Month Avg.DAU",
                        "cnName": "月平均日活跃",
                        "rainbowKey": "Month Avg.DAU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "pay_amount",
                        "reqMetricKey": "pay_amount",
                        "enPercentWidth": 190,
                        "cnPercentWidth": 190,
                        "enWidth": 115,
                        "cnWidth": 115,
                        "enName": "Revenue($)",
                        "cnName": "付费金额($)",
                        "rainbowKey": "Revenue($)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "avg_pay_amount",
                        "reqMetricKey": "avg_pay_amount",
                        "enPercentWidth": 190,
                        "cnPercentWidth": 180,
                        "enWidth": 200,
                        "cnWidth": 150,
                        "enName": "Month Avg.Revenue($)",
                        "cnName": "月均付费金额($)",
                        "rainbowKey": "Month Avg.Revenue($)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "pcu",
                        "reqMetricKey": "pcu",
                        "enPercentWidth": 152,
                        "cnPercentWidth": 152,
                        "enWidth": 77,
                        "cnWidth": 112,
                        "enName": "PCU",
                        "cnName": "最高同时在线",
                        "rainbowKey": "PCU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "acu",
                        "reqMetricKey": "acu",
                        "enPercentWidth": 152,
                        "cnPercentWidth": 152,
                        "enWidth": 77,
                        "cnWidth": 112,
                        "enName": "ACU",
                        "cnName": "平均同时在线",
                        "rainbowKey": "ACU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "aot",
                        "reqMetricKey": "aot",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 164,
                        "cnWidth": 190,
                        "enName": "Avg.Playtime(min)",
                        "cnName": "平均在线时长(分钟)",
                        "rainbowKey": "Avg.Playtime(min)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "m2",
                        "reqMetricKey": "m2",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 80,
                        "enName": "M2",
                        "cnName": "次月留存",
                        "rainbowKey": "M2",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "m3",
                        "reqMetricKey": "m3",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 80,
                        "enName": "M3",
                        "cnName": "3月留存",
                        "rainbowKey": "M3",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "m4",
                        "reqMetricKey": "m4",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 80,
                        "enName": "M4",
                        "cnName": "4月留存",
                        "rainbowKey": "M4",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "paid_users",
                        "reqMetricKey": "paid_users",
                        "enPercentWidth": 150,
                        "cnPercentWidth": 150,
                        "enWidth": 64,
                        "cnWidth": 80,
                        "enName": "Payer",
                        "cnName": "付费人数",
                        "rainbowKey": "Payer",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "payer_rate",
                        "reqMetricKey": "payer_rate",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 76,
                        "cnWidth": 96,
                        "enName": "Payer%",
                        "cnName": "付费渗透率",
                        "rainbowKey": "Payer%",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "arpu",
                        "reqMetricKey": "arpu",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 126,
                        "enWidth": 96,
                        "cnWidth": 106,
                        "enName": "ARPU($)",
                        "cnName": "活跃ARPU($)",
                        "rainbowKey": "ARPU($)",
                        "type": "decimals",
                        "decimal": 5,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "arppu",
                        "reqMetricKey": "arppu",
                        "enPercentWidth": 152,
                        "cnPercentWidth": 152,
                        "enWidth": 106,
                        "cnWidth": 136,
                        "enName": "ARPPU($)",
                        "cnName": "付费ARPPU($)",
                        "rainbowKey": "ARPPU($)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "new_paid_users",
                        "reqMetricKey": "new_paid_users",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 144,
                        "cnWidth": 126,
                        "enName": "First-time Payer",
                        "cnName": "首次付费用户",
                        "rainbowKey": "First-time Payer",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "new_pay_amount",
                        "reqMetricKey": "new_pay_amount",
                        "enPercentWidth": 220,
                        "cnPercentWidth": 210,
                        "enWidth": 220,
                        "cnWidth": 165,
                        "enName": "Revenue(first-time payer)",
                        "cnName": "首次付费用户金额",
                        "rainbowKey": "Revenue(first-time payer)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "new_arppu",
                        "reqMetricKey": "new_arppu",
                        "enPercentWidth": 240,
                        "cnPercentWidth": 200,
                        "enWidth": 240,
                        "cnWidth": 200,
                        "enName": "First-time Payer ARPPU($)",
                        "cnName": "首次付费用户ARPPU($)",
                        "rainbowKey": "First-time Payer ARPPU($)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "alc",
                        "reqMetricKey": "alc",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 140,
                        "enWidth": 160,
                        "cnWidth": 140,
                        "enName": "Sessions per user",
                        "cnName": "平均登录次数",
                        "rainbowKey": "Sessions per user",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "retention_users",
                        "reqMetricKey": "retention_users",
                        "enPercentWidth": 190,
                        "cnPercentWidth": 190,
                        "enWidth": 200,
                        "cnWidth": 171,
                        "enName": "DAU Retention Users",
                        "cnName": "日活留存",
                        "rainbowKey": "DAU Retention Users",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "churn_users",
                        "reqMetricKey": "churn_users",
                        "enPercentWidth": 170,
                        "cnPercentWidth": 170,
                        "enWidth": 114,
                        "cnWidth": 95,
                        "enName": "Churn Users",
                        "cnName": "月流失",
                        "rainbowKey": "Churn Users",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "churn_rate",
                        "reqMetricKey": "churn_rate",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 80,
                        "cnWidth": 64,
                        "enName": "Churn%",
                        "cnName": "流失率",
                        "rainbowKey": "Churn%",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "return_users",
                        "reqMetricKey": "return_users",
                        "enPercentWidth": 180,
                        "cnPercentWidth": 170,
                        "enWidth": 170,
                        "cnWidth": 95,
                        "enName": "MAU Return Users",
                        "cnName": "月回流",
                        "rainbowKey": "MAU Return Users",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "weighted_m2",
                        "reqMetricKey": "weighted_m2",
                        "enPercentWidth": 150,
                        "cnPercentWidth": 145,
                        "enWidth": 126,
                        "cnWidth": 112,
                        "enName": "Weighted M2",
                        "cnName": "加权次月留存",
                        "rainbowKey": "Weighted M2",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "weighted_m3",
                        "reqMetricKey": "weighted_m3",
                        "enPercentWidth": 150,
                        "cnPercentWidth": 145,
                        "enWidth": 126,
                        "cnWidth": 112,
                        "enName": "Weighted M3",
                        "cnName": "加权3月留存",
                        "rainbowKey": "Weighted M3",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "weighted_m4",
                        "reqMetricKey": "weighted_m4",
                        "enPercentWidth": 150,
                        "cnPercentWidth": 145,
                        "enWidth": 126,
                        "cnWidth": 112,
                        "enName": "Weighted M4",
                        "cnName": "加权4月留存",
                        "rainbowKey": "Weighted M4",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      }
                    ]
                  }
                }
              }
            }
          ]
        }
      ]
    }
  ]
};